module.exports = __webpack_public_path__ + "static/media/delete_gray.aa382843.svg";